<template>
  <InputRadioGroup
    v-if="
      store.conditionOptionsToDisplay.length > 0 &&
      !store.onlyNewConditionOptionExists
    "
    legend="Skick"
    type-class="product-page"
  >
    <InputRadioButton
      v-for="condition in store.conditionOptionsToDisplay"
      :id="store.currentVariant?.ColorProductAttributeValueId + condition"
      :key="store.currentVariant?.ColorProductAttributeValueId + condition"
      v-model="store.productState.selectedCondition"
      :value="condition"
      :label="condition"
      :simple-label="true"
      :group-name="`condition-${groupNameId}`"
      @update:model-value="store.changeOption('condition')"
    />
    <div class="col-span-full">
      <button
        class="flex align-middle gap-8 p-9 items-center body-link-md text-text-link underline halebop-focus hover:text-text-link-hover active:bg-surface-action-hover"
        @click="isDrawerOpen = true"
      >
        <nuxt-icon name="info" aria-hidden="true" />
        <span> Läs om våra skick </span>
      </button>
    </div>
  </InputRadioGroup>
  <AppDrawer v-model="isDrawerOpen" dialog-titel="Mer info om lurarnas skick">
    <template #header>
      <div class="flex gap-8 flex-col">
        <h2 class="heading-xs">Om lurarnas skick</h2>
        <p>
          Vi kvalitetssäkrar alla lurar noggrant och säkerställer att all
          funktionalitet är som den ska.
        </p>
      </div>
    </template>
    <div class="flex flex-col gap-32">
      <div class="flex flex-col gap-16">
        <p class="heading-xxs">Vad innebär de olika skicken?</p>
        <InfoCard>
          <template #header>
            <div class="flex gap-16 items-center">
              <nuxt-icon
                name="used/good"
                class="text-[2.4rem] mb-0"
                aria-hidden="true"
              />
              <h3 class="heading-xs">Bra skick</h3>
            </div>
          </template>
          <p>
            En lur som är i Bra skick är fullt fungerande men kan vara synligt
            använd med mindre repor.
          </p>
        </InfoCard>
        <InfoCard>
          <template #header>
            <div class="flex gap-16 items-center">
              <nuxt-icon
                name="used/perfect"
                class="text-[2.4rem] mb-0"
                aria-hidden="true"
              />
              <h3 class="heading-xs">Perfekt skick</h3>
            </div>
          </template>
          <p>
            En lur som är i Perfekt skick är knappt använd. Luren fungerar
            precis som den ska och har inga eller väldigt få synliga repor.
          </p>
        </InfoCard>
      </div>
      <div class="flex flex-col gap-16">
        <h4 class="heading-xxs">Följande har kontrollerats:</h4>
        <PdpCheckIconWithLabel label="Av- och påknapp" />
        <PdpCheckIconWithLabel label="Mobilens knappar och touchskärm" />
        <PdpCheckIconWithLabel label="Fingertrycksläsare" />
        <PdpCheckIconWithLabel label="SD-port" />
        <PdpCheckIconWithLabel label="AUX-port" />
        <PdpCheckIconWithLabel label="Nätverk och wifi-enheter" />
        <PdpCheckIconWithLabel label="Kameror, fram- och bak" />
        <PdpCheckIconWithLabel label="Högtalare och mikrofon" />
        <PdpCheckIconWithLabel label="Gyrosensor" />
        <PdpCheckIconWithLabel label="Ansiktsigenkänning" />
      </div>
      <div class="flex flex-col gap-16">
        <h4 class="heading-xxs">Vi har även säkrat följande:</h4>
        <PdpCheckIconWithLabel label="Att allt innehåll är borttaget" />
        <PdpCheckIconWithLabel label="Att mobilen är olåst" />
        <PdpCheckIconWithLabel label="Mobilen är fri från vattenskador" />
      </div>
    </div>
  </AppDrawer>
</template>

<script lang="ts" setup>
const store = useMyProductPageStore();
const isDrawerOpen = ref(false);
const groupNameId = useId();
</script>

<style scoped></style>
